export default {
  methods: {
    lordIconColors(primaryCssVar, secondaryCssVar = null) {
      const primaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue(primaryCssVar)
        .trim();
      const secondaryColor = getComputedStyle(document.documentElement)
        .getPropertyValue(secondaryCssVar || primaryCssVar)
        .trim();

      const fallback = '#196CAE';

      return `primary:${primaryColor || fallback},secondary:${
        secondaryColor || fallback
      }`;
    },
  },
  created() {
    const element = document.getElementById('lordIconScript');

    if (element) {
      return;
    }

    let lordIconScript = document.createElement('script');
    lordIconScript.id = 'lordIconScript';
    lordIconScript.setAttribute('src', 'https://cdn.lordicon.com/mssddfmo.js');
    document.head.appendChild(lordIconScript);
  },
};
